import React from 'react';
import CategoryComponent from './CategoryComponent';

export default props => {
    return props.categories.map((category, index) => <CategoryComponent key={category._id} clickHandler={(event) => props.clickHandler(event, index)} category={category}/>)
};